import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { useAuth } from '../modules/auth/hooks/UseAuth'
import { appPages, homePath } from './appPages'

export function PrivateRoutes() {
  const { roleList } = useAuth()
  const home = homePath(roleList)

  return (
    <Switch>
      {appPages.map(({ path, component: Page, canAccess }) => (
        <Route
          key={path}
          path={path}
          render={() => (canAccess(roleList) ? <Page /> : <Redirect to={home} />)}
        />
      ))}
      <Redirect from='/auth' to={home} />
      <Redirect exact from='/' to={home} />
      <Redirect to='error/404' />
    </Switch>
  )
}
